import { render, staticRenderFns } from "./CommonDaysPage.vue?vue&type=template&id=b95ae6a0&scoped=true"
import script from "./CommonDaysPage.vue?vue&type=script&lang=js"
export * from "./CommonDaysPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95ae6a0",
  null
  
)

export default component.exports